var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCompanyInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 239,
    viewBox: "0 0 301 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M299.362 1L244.006 108.812L243.258 110.269H300V238H166.038V116.921L238.487 1H299.362ZM134.718 1L78.1523 108.805L77.3838 110.269H135.371V238H1V116.917L72.2256 1H134.718Z",
    stroke: "#7A69FA",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompanyInformation);
export default __webpack_public_path__ + "static/media/icon-company-information.c648333d92005d7f3b506b202ceb906a056c25b904f35aebda72768c83f409c8.svg";
export { ForwardRef as ReactComponent };